var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"pb-10 mb-40 border-b-2 border-grey-100"},[_c('Back',{staticClass:"py-10 inline-block",attrs:{"route":{ name: 'learn' },"title":"learn.back_to_learn"}})],1),_vm._l((_vm.articles),function(article){return _c('Article',{key:article.contentId,attrs:{"article":article,"type":_vm.type}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }